export const hasMainInviteToken = (query = {}) => {
  return Boolean(query.invite && String(query.invite).trim())
}

export const nextForSignupMain = (to = {}) => {
  const isMainSignup = to.name === 'SignupMain' || to.path === '/main'
  if (!isMainSignup) return null
  if (hasMainInviteToken(to.query)) return null
  return { path: '/mini' }
}
